import Footer from "../../components/footer"
import Header from "../../components/header"
import SideBar from "../../components/sidebar"
import services from "../../services"
import { Link, useNavigate } from "react-router-dom";
import Toaster from "../../components/toaster";
import { useEffect, useState } from "react";
import { requestPermission } from "../../firebase";

import { PushNotifications } from '@capacitor/push-notifications';
import useIsMobile from "../../hooks/useIsMobile";
import MobileHeader from "../../components/MobileHeader";

const Login = () => {
    let navigate = useNavigate();
    const isMobile = useIsMobile();

    const [phoneNumber, setPhoneNumber] = useState('')
    const [otp, setOtp] = useState('')
    const [response, setresponse] = useState('')
    const [agreed, setAgreed] = useState(true)
    const [selectlng, setselectlng] = useState(null)
    const [toaster, setToaster] = useState({ visiblity: "hide" });
    function isRunningInCapacitor() {
        return window.Capacitor !== undefined;
    }
    function setCookie(key, value, expiry) {
        
        document.cookie = `googtrans=${value}; domain=.cars53.in; path=/;`;
        document.cookie = `googtrans=${value}; domain=partner.cars53.in; path=/;`;
        document.cookie = `googtrans=${value}; domain=.partner.cars53.in; path=/;`;
    }
    function deleteAllCookies() {
        const cookies = document.cookie.split(";");
    
        cookies.forEach(cookie => {
            const eqPos = cookie.indexOf("=");
            const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
    
            // Delete cookie for current path
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/";
    
            // Delete cookie for root path and subdomains
            const domainParts = window.location.hostname.split(".");
            for (let i = 0; i < domainParts.length; i++) {
                const domain = domainParts.slice(i).join(".");
    
                // Delete cookies for all paths on each subdomain
                document.cookie = name + `=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=.${domain}`;
            }
            window.location.reload(true)
        });
    }
    
    
    
    function googleTranslateElementInit(lng) {
        setCookie('googtrans', lng, 1);
        window.location.reload(true)
        // new google.translate.TranslateElement({
        //    pageLanguage: 'en'
        // }, 'google_translate_element');
    }
    
    function getCookie(name) {
        const value = document.cookie;
        
        const singlevalue = value.split(';')
        
        const parts = singlevalue[0];
        console.log(parts,parts.split('=')[1])
        if(parts){
            return parts.split('=')[1]
        }
       
      }
    const handleGenerateOTP = async (event) => {
        // event.preventDefault();
        // navigate("/users");
        try {
            let payLoad = {
                phoneNumber: phoneNumber,
                countryCode: '+91',
            }

            const response = await services.auth.GENERATE_OTP(payLoad);
            if (response.data) {
                setresponse(response.data)
            }

            if (response) {
                setToaster({
                    type: "success",
                    title: "Successful",
                    text: "OTP sent successfully",
                    visiblity: "show",
                });

            }


        } catch (error) {
            setToaster({
                type: "danger",
                title: "Error Occured",
                text: error?.response?.data?.message,
                visiblity: "show",
            });
            setTimeout(() => {
                setToaster({
                    visiblity: "hide",
                });
            }, 1500);
        }

    };
    const getToken = async () => {
        // Push token is optional (notifications only). Log in with or without it,
        // and never retry in a loop — a missing/aborted service worker used to
        // recurse here forever and hang the Submit button.
        try {
            const token = await requestPermission();
            submitOtp(token || undefined);
        } catch (error) {
            console.log('Push token unavailable, continuing login without it:', error);
            submitOtp();
        }
    }
    const handleMobileToken = async () => {
        if (isRunningInCapacitor() && window.Capacitor.platform !== 'web') {
            // The push token is optional for login — never let it block or hang the
            // OTP submit. Log in as soon as we get a token OR on any failure
            // (permission denied, registration error) OR after a short timeout.
            let done = false;
            const finish = (token) => {
                if (done) return;
                done = true;
                submitOtp(token);
            };
            // Safety net: iOS registration can stall or fail silently (e.g. missing
            // APNs entitlement) — proceed without a token after a short wait.
            const timeout = setTimeout(() => finish(), 3500);

            try {
                PushNotifications.addListener('registration', (token) => {
                    clearTimeout(timeout);
                    finish(token.value);
                });
                PushNotifications.addListener('registrationError', (err) => {
                    console.log('Push registration error, continuing login without token:', err);
                    clearTimeout(timeout);
                    finish();
                });
                PushNotifications.addListener('pushNotificationReceived', () => {});
                PushNotifications.addListener('pushNotificationActionPerformed', () => {});

                const result = await PushNotifications.requestPermissions();
                if (result.receive === 'granted') {
                    PushNotifications.register();
                } else {
                    clearTimeout(timeout);
                    finish();
                }
            } catch (error) {
                console.log('Push permission/registration failed, continuing login:', error);
                clearTimeout(timeout);
                finish();
            }
        } else {
            getToken()
        }
    }
    const submitOtp = async (token) => {
        try {
            let payload = {
                phoneNumber: phoneNumber,
                otp: otp,
                countryCode: '+91',

            }
            if (token) {

                payload.firebaseToken = token;
            }

            const response = await services.auth.LOGIN_WITH_OTP(payload)
            console.log(response)
            localStorage.setItem('user_id', JSON.stringify(response.data.user))
            if (response.data) {
                if (response.data.user.VendorDetail.approvalStatus == 'pending') {
                    window.location.replace('/myprofile');

                } else {
                    window.location.replace('/');

                }
                setToaster({
                    type: "success",
                    title: "Login",
                    text: 'Login successfully',
                    visiblity: "show",
                });

            }


        } catch (error) {
            console.log(error)
            setToaster({
                type: "danger",
                title: "Failed",
                text: 'Invalid OTP',
                visiblity: "show",
            });
        }
    }
    useEffect(()=>{
        const lng = getCookie('googtrans');
        console.log(lng)
        if(lng){
            setselectlng(lng)
        } 
    },[])
   
    if (isMobile) {
        return (
            <>
                <Toaster type={toaster.type} title={toaster.title} text={toaster.text} visiblity={toaster.visiblity} />
                <main className="mlux mlux-auth">
                    <MobileHeader />

                    <div className="mlux-auth-figure" data-rise="1">
                        <div className="ring"></div>
                        <div className="badge-ic"><i className={response ? "far fa-shield-check" : "far fa-user-tie"}></i></div>
                    </div>

                    <div className="mlux-auth-head" data-rise="1" style={{ textAlign: 'center' }}>
                        <h1>{response ? "Verify your number" : "Partner Login"}</h1>
                        <p>{response
                            ? <>Enter the code we sent to <b>+91 {phoneNumber}</b></>
                            : "Sign in to manage your cabs, bookings & earnings."}</p>
                    </div>

                    <div className="mlux-card" style={{ padding: 16, marginTop: 18 }} data-rise="2">
                        {!response ? (
                            <>
                                <label className="mlux-lbl">Phone number</label>
                                <div className="mlux-field with-prefix">
                                    <span className="mlux-prefix">+91</span>
                                    <input type="number" inputMode="numeric" value={phoneNumber} placeholder="98765 43210"
                                        onChange={(e) => setPhoneNumber(e.target.value)}
                                        onKeyDown={(e) => { if (e.key === "Enter") handleGenerateOTP(); }} />
                                </div>
                                {phoneNumber.length > 10 && <small style={{ color: "#ef4444", display: "block", margin: "0 0 8px 4px" }}>Please enter a valid phone number</small>}
                                <label className="mlux-agree">
                                    <input type="checkbox" checked={agreed} onChange={(e) => setAgreed(e.target.checked)} />
                                    <span>I agree to the <Link to="/terms">Terms &amp; Conditions</Link>.</span>
                                </label>
                                <button className="mlux-btn" disabled={phoneNumber.length !== 10 || !agreed} onClick={() => handleGenerateOTP()}>
                                    <i className="far fa-paper-plane"></i> Get OTP
                                </button>
                            </>
                        ) : (
                            <>
                                <label className="mlux-lbl">Enter OTP</label>
                                <div className="mlux-field no-icon mlux-otp">
                                    <input type="number" inputMode="numeric" value={otp} placeholder="––––"
                                        onChange={(e) => setOtp(e.target.value)}
                                        onKeyDown={(e) => { if (e.key === "Enter") handleMobileToken(); }} />
                                </div>
                                <button className="mlux-btn" disabled={!otp} onClick={() => handleMobileToken()}>
                                    <i className="far fa-circle-check"></i> Verify &amp; continue
                                </button>
                                <div className="mlux-auth-alt">
                                    <button onClick={() => setresponse("")}>Change number</button>
                                    <span>·</span>
                                    <button onClick={() => handleGenerateOTP()}>Resend OTP</button>
                                </div>
                            </>
                        )}
                    </div>

                    <div className="mlux-secure"><i className="fas fa-lock"></i> Secure OTP login — no password needed</div>
                    <p className="mlux-auth-foot">New partner? <Link to="/register">Register here</Link></p>
                </main>
            </>
        );
    }

    return (<>
        <Header />
        <SideBar />
        <main class="main">
            <Toaster
                type={toaster.type}
                title={toaster.title}
                text={toaster.text}
                visiblity={toaster.visiblity}
            />
            <div class="site-breadcrumb" style={{ background: "url(assets/img/breadcrumb/01.jpg)" }}>
                <div class="container">
                    <h2 class="breadcrumb-title">Welcome to Cars53</h2>
                    <ul class="breadcrumb-menu">
                        <li><a href="index.html">Home</a></li>
                        <li class="active">Login</li>
                    </ul>
                </div>
            </div>


            <div class="login-area py-5">
                <div class="container">
                    <div class="col-md-5 mx-auto">
                        <div class="login-form">
                            <div class="login-header">
                                <img src="/assets/img/logo/partner-logo.png" alt="Cars53 Partner" className="brand-logo" />
                                <p>Login with your Cars53 partner account</p>
                            </div>

                            {response ? <>
                                <div class="form-group">
                                    <label>Password</label>
                                    <input type="password" onChange={(e) => setOtp(e.target.value)}
                                        value={otp}
                                        className="form-control"
                                        name="password"
                                        onKeyDown={(e) => {
                                            e.key === "Enter"
                                                ? handleMobileToken()
                                                : setOtp(e.target.value);

                                        }} placeholder="Enter OTP" />
                                </div>  <div class="d-flex align-items-center">
                                    <button onClick={() => handleMobileToken()} type="submit" class="theme-btn"><i class="far fa-sign-in"></i> Submit OTP</button>
                                </div></> :
                                <> <div class="form-group">
                                    <label>Phone Number</label>
                                    <input type="number" value={phoneNumber}
                                        placeholder="Enter your phone"
                                        onChange={(e) => setPhoneNumber(e.target.value)}
                                        onKeyDown={(e) => {
                                            e.key === "Enter"
                                                ? handleGenerateOTP()
                                                : setPhoneNumber(e.target.value);
                                        }} class="form-control" />
                                    {phoneNumber.length > 10 && <small className="text-danger">Please enter valid phone number</small>}
                                </div>
                                    <div class="d-flex align-items-center">
                                        <button disabled={phoneNumber.length > 10} onClick={() => handleGenerateOTP()} type="submit" class="theme-btn"><i class="far fa-sign-in"></i> GET OTP</button>
                                    </div> </>
                            }


                            <div class="login-footer">
                                {selectlng == '/en/hi' ? <p className="cursor-pointer" onClick={()=>deleteAllCookies()}>Change language to <span className="fw-bolder text-warning">English</span></p>:
                                <p className="cursor-pointer" onClick={() => googleTranslateElementInit('/en/hi')}>Change language to <span className="fw-bolder text-warning">Hindi</span></p>}

                                {/* <div class="social-login">
                                    <p>Continue with social media</p>
                                    <div class="social-login-list">
                                        <a href="#"><i class="fab fa-facebook-f"></i></a>
                                        <a href="#"><i class="fab fa-google"></i></a>
                                        <a href="#"><i class="fab fa-twitter"></i></a>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </main>
        <Footer />
    </>)
}
export default Login